<template>
  <div v-if="Object.keys(basicInfo).length" style="padding: 15px 0">
    <div style="display: flex; justify-content: space-between; align-items: center">
      <div>
        <span class="title">个人基本信息</span>
        <a-range-picker v-model="dateRang" style="width: 240px; margin-left: 10px" />
        <a-button type="primary" style="margin-left: 10px" @click="handleSearch">查询</a-button>
      </div>
      <div>学生档案数据统计</div>
    </div>
    <div class="personal-card">
      <div class="avatar">
        <img :src="$getStoreHttpUrl(basicInfo.pic)" style="width: 100%; height: 100%" alt="头像" />
      </div>
      <div class="personal-info">
        <div>姓名：{{ basicInfo.studentName }}</div>
        <div>学校：{{ basicInfo.schoolName }}</div>
        <div>班级：{{ basicInfo.className }}</div>
        <div>提醒次数：{{ basicInfo.warnCnt }}次</div>
      </div>
      <div class="personal-info">
        <div>家长电话：{{ basicInfo.phone }}</div>
        <div>关爱名单：{{ getDictCodeData(basicInfo.careList) }}</div>
      </div>
      <div class="color-box-area">
        <!-- <div>正常</div> -->
        <div class="color-box" v-for="(item, index) in statusList" :key="index">
          <div style="height: 35px">
            <img
              v-if="basicInfo.careList == index"
              src="@/assets/careListPos.png"
              alt="正常"
              style="width: auto; height: 100%"
            />
          </div>
          <div :style="{ backgroundColor: item.color, width: '60px', height: '24px' }"></div>
          <div style="margin: 20px 0">
            <span class="iconfont" :style="{ backgroundColor: item.color }"></span>
            {{ item.label }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <EmptyData v-else :styleObj="{ padding: '30px 0' }" :loading="loading" />
</template>

<script>
import { formatMomentDate, getDictCodeData, getYearStarting } from '@/utils/util'
import { getDaysDateRange } from '@/utils/date'
import moment from 'moment'

export default {
  name: 'PersonalDetails',
  props: {
    basicInfoProp: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    beginDate: {
      type: String,
      default: '',
    },
    endDate: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      schoolYear: '',
      queryParam: {},
      dateRang: [],
      statusList: [
        {
          label: '正常',
          color: '#1783E8',
        },
        {
          label: '一级',
          color: '#FFD821',
        },
        {
          label: '二级',
          color: '#FA9600',
        },
        {
          label: '三级',
          color: '#EB3D2F',
        },
      ],
      basicInfo: {},
    }
  },
  created() {
    // this.setDefaultSchoolYear()
    if (this.beginDate && this.endDate) {
      this.dateRang = [moment(this.beginDate), moment(this.endDate)]
    } else {
      this.dateRang = getDaysDateRange()
    }
  },
  watch: {
    basicInfoProp: {
      handler(val) {
        this.basicInfo = val
      },
    },
    beginDate: {
      handler(val) {
        if (val && this.dateRang[0] && moment(val).format('YYYY-MM-DD') !== this.dateRang[0].format('YYYY-MM-DD')) {
          this.$set(this.dateRang, 0, moment(val))
        }
      }
    },
    endDate: {
      handler(val) {
        if (val && this.dateRang[1] && moment(val).format('YYYY-MM-DD') !== this.dateRang[1].format('YYYY-MM-DD')) {
          this.$set(this.dateRang, 1, moment(val))
        }
      }
    }
  },
  methods: {
    handleSearch() {
      this.$set(this.queryParam, 'beginDate', formatMomentDate(this.dateRang[0]))
      this.$set(this.queryParam, 'endDate', formatMomentDate(this.dateRang[1]))
      this.$emit('search', this.queryParam)
    },
    getDictCodeData(status) {
      const res = getDictCodeData('care_list', this.basicInfo.careList)
      return res.text || ''
    },
  },
}
</script>
<style scoped lang="less">
.title {
  font-size: 18px;
  font-weight: bold;
}

.personal-card {
  display: flex;
  align-items: center;
  padding: 15px;
  margin: 15px 0;
  background-color: #eaf5ff;
  border-radius: 5px;

  .avatar {
    width: 90px;
    height: 120px;
    border: 1px solid #ccc;
    border-radius: 4px;
    overflow: hidden;
  }

  .personal-info {
    padding: 0 20px;
    color: #3b3d3e;

    > div {
      line-height: 30px;
    }
  }

  .color-box-area {
    display: flex;
    margin-left: auto;
    margin-right: 150px;

    .color-box {
      display: flex;
      flex-direction: column;
      align-items: center;

      .iconfont {
        display: inline-block;
        width: 9px;
        height: 9px;
        border-radius: 50%;
      }
    }
  }
}
</style>
